/**
 * IA NAS AGENCIAS — VIDEO 9/9 (CTA)
 * SlideType: profile-cta | 10s | 720x900
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate, Easing} from "remotion";
import {TOKEN_PRESETS, FONT_PRESETS} from "../../templates/carrossel/EditorialTechNews";

const CLAMP = {extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const};
const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

export const IAA09CTA: React.FC = () => {
  const frame = useCurrentFrame();
  const scale = interpolate(frame, [0, 15], [0.8, 1], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });
  const op = fadeIn(frame, 0, 15);

  return (
    <AbsoluteFill style={{backgroundColor: "#1A1D26", justifyContent: "center", alignItems: "center"}}>
      <div style={{position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px"}} />
      <div style={{position: "absolute", top: 30, left: 50, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_PRESETS.mono, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: "#888888"}}>IA NAS AGENCIAS</div>
      <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 16}}>
        <div style={{position: "relative", width: 100, height: 100, opacity: op}}>
          {[3, 2, 1].map((ring) => (
            <div key={ring} style={{position: "absolute", inset: (ring - 1) * -20, borderRadius: "50%", border: "1px solid rgba(0,0,0,0.06)", transform: `scale(${scale})`}} />
          ))}
          <div style={{width: 100, height: 100, borderRadius: "50%", overflow: "hidden", border: "2px solid rgba(0,0,0,0.1)", transform: `scale(${scale})`, background: "#00DF82", display: "flex", alignItems: "center", justifyContent: "center"}}>
            <span style={{fontSize: 40, fontWeight: 800, color: "#000"}}>GR</span>
          </div>
        </div>
        <div style={{opacity: fadeIn(frame, 15, 30), transform: `translateY(${slideUp(frame, 15, 30)})`, fontFamily: FONT_PRESETS.serif, fontSize: 44, fontWeight: 700, lineHeight: 1.15, color: "#FFFFFF", maxWidth: 620, textAlign: "center"}}>Se isso fez sentido, salva.</div>
        <div style={{opacity: fadeIn(frame, 25, 40), fontFamily: FONT_PRESETS.serif, fontSize: 22, fontWeight: 400, lineHeight: 1.4, color: "#C8C4C0", maxWidth: 620, textAlign: "center", fontStyle: "italic"}}>No Stories vou mostrar o workflow completo. Abre a caixinha de notificação.</div>
        <div style={{width: 40, height: 2, background: "#888888", marginTop: 16, marginBottom: 16, opacity: fadeIn(frame, 35, 45)}} />
        <span style={{opacity: fadeIn(frame, 35, 45), fontFamily: FONT_PRESETS.sans, fontSize: 15, color: "#888888"}}>@guilhermeribeiro.ai</span>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
